module.exports = __webpack_public_path__ + "img/13.918988b5.png";